export default __webpack_public_path__ + "static/media/OpenBank Delayed.4707cb21.wav";